import { __rest } from "tslib";
import React, { useMemo } from 'react';
import { block } from '../utils/cn';
import { Popup } from '../Popup';
import { Menu } from '../Menu';
import { toItemList } from './toItemList';
const b = block('dropdown-menu');
const SEPARATOR = { text: '', action: () => { } };
export const DropdownMenuPopup = ({ items, open, anchorRef, onMenuItemClick, onClose, popupClassName, placement, size, menuProps, children, }) => {
    const content = useMemo(() => {
        return (children || (React.createElement(Menu, Object.assign({ className: b('menu'), size: size }, menuProps), toItemList(items, SEPARATOR).map((item, index) => {
            const { text, action, className } = item, itemProps = __rest(item, ["text", "action", "className"]);
            return (React.createElement(Menu.Item, Object.assign({ key: index, className: b('menu-item', { separator: item === SEPARATOR }, className), onClick: (event) => onMenuItemClick(event, action) }, itemProps), text));
        }))));
    }, [children, size, menuProps, items, onMenuItemClick]);
    return (React.createElement(Popup, { open: open, anchorRef: anchorRef, className: popupClassName, placement: placement, onClose: onClose }, content));
};
